import React from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from '../Captcha';


class Contact extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            subject: '',
            message: '',
        }
    }
    OnNameChange(event) {
        this.setState({ name: event.target.value })
    }
    OnEmailChange(event) {
        this.setState({ email: event.target.value })
    }
    OnSubjectChange(event) {
        this.setState({ subject: event.target.value })
    }
    OnMessageChange(event) {
        this.setState({ message: event.target.value })
    }

    SubmitEmail(event) {
        event.preventDefault();
        document.getElementById('msgSubmit').innerHTML = '';
        document.getElementById("form-submit").disabled = true;
        let user_captcha_value = document.getElementById('captcha').value;
        if (!this.state.name || !this.state.email || !this.state.message) {
            document.getElementById('msgSubmit').innerHTML = ('<p class="text-danger mt-2">Some Fields are Empty!</p>');
            document.getElementById("form-submit").disabled = false;
        } else {
            if (validateCaptcha(user_captcha_value) === true) {
                fetch('https://www.appxcube.com/assets/php/form-process.php', {
                    method: "POST",
                    body: JSON.stringify(this.state),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                }).then(
                    (response) => (response.json())
                ).then((response) => {
                   // console.log(response.status);
                    if(response.status === "success"){
                        document.getElementById('msgSubmit').innerHTML = ('<p class="text-primary mt-2">'+response.msg+'</p>');
                    }else if(response.status === "fail"){
                        document.getElementById('msgSubmit').innerHTML = ('<p class="text-danger mt-2">'+response.msg+'</p>');
                    }else {
                        document.getElementById('msgSubmit').innerHTML = ('<p class="text-danger mt-2">Something Went Wrong</p>');
                    }
                    document.getElementById("form-submit").disabled = false;
                })
            }

            else {
                document.getElementById('msgSubmit').innerHTML = ('<p class="text-danger mt-2">Captcha Does Not Match!</p>');
                document.getElementById("form-submit").disabled = false;
            }

        }

    }
    componentDidMount() {
        loadCaptchaEnginge(6);
    };
    render() {
        return (
            <div id="contact" className="section-padding">
                <div className="container">
                    <div className="row contact-form-area wow fadeInUp" data-wow-delay="0.4s">
                        <div className="col-md-6 col-lg-6 col-sm-12">
                            <div className="contact-block">
                                <form id="contactForm" onSubmit={this.SubmitEmail.bind(this)} action="POST">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="text" className="form-control" id="name" name="name" placeholder="Name" value={this.state.name} onChange={this.OnNameChange.bind(this)} required />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="email" placeholder="Email" id="email" className="form-control" name="email" value={this.state.email} onChange={this.OnEmailChange.bind(this)} required />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <input type="text" placeholder="Subject" id="subject" name="subject" className="form-control" value={this.state.subject} onChange={this.OnSubjectChange.bind(this)} required />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea className="form-control" id="message" name="message" placeholder="Your Message" rows="5" value={this.state.message} onChange={this.OnMessageChange.bind(this)} required></textarea>

                                            </div>

                                            <div className="row">
                                                <div id="capcha-cs" className="col-lg-3 col-md-6 col-4">
                                                    <LoadCanvasTemplate />
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-8">
                                                    <input type="text" placeholder="Enter Captcha" id="captcha" name="captcha" className="form-control" />
                                                </div>
                                                <div className="col-lg-5 col-md-12 col-12">
                                                    <div className="submit-button">
                                                        <button className="btn btn-common float-right" id="form-submit" type="submit">Send Message</button>

                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div id="msgSubmit" className="text-center"></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 cs-margin">
                            <div className="contact-right-area wow fadeIn">
                                <div className="contact-title">
                                    <h1>We're a friendly bunch..</h1>
                                    <p>We create projects for companies and startups with a passion for quality</p>
                                </div>
                                <h2>Contact Us</h2>
                                <div className="contact-right">
                                    <div className="single-contact">
                                        <div className="contact-icon">
                                            <i className="lni-map-marker"></i>
                                        </div>
                                        <p>ADDRESS: 5-9-22, 303, 3rd Floor, My Home Sarovar Plaza, Secretariat Road, Saifabad, Hyderabad</p>
                                    </div>
                                    <div className="single-contact">
                                        <div className="contact-icon">
                                            <i className="lni-envelope"></i>
                                        </div>
                                        <p><a href="mailto:connect@appxcube.com">Email:  connect@appxcube.com</a></p>
                                    </div>
                                    <div className="single-contact">
                                        <div className="contact-icon">
                                            <i className="lni-phone-handset"></i>
                                        </div>
                                        <p><a href="tel:9154992845">Phone:  +91 9154992845</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



export default Contact;


// WEBPACK FOOTER //
// ./src/sections/Contact.js